import { ReactElement } from "react";
import { cn } from "@util/helpers";

export type SubscriberIconProps = {
  className?: string;
};

/**
 * SubscriberIcon
 * Description: The subscriber icon of the article
 * @param {SubscriberIconProps} props
 * @returns {ReactElement}
 *
 */
const SubscriberIcon = ({ className }: SubscriberIconProps): ReactElement => {
  return (
    <div
      className={cn(
        "h-[10px] w-[10px] rotate-45 rounded-[2.5px] bg-orange-300",
        className
      )}
      data-testid="subscriber-icon-component"
    ></div>
  );
};

export default SubscriberIcon;
